import { CollectionView } from '../components'
import { persist } from '../config/persist.config'
import { ValueOf } from '../types'

export interface IPersistObject {
  collectionView?: CollectionView
  activeSortBy?: string
  [key: string]: ValueOf<IPersistObject>
}

class PersistService {
  rootKey: string = persist.rootKey // Changed from CONFIG.persist.rootKey for IE10 compatibility
  object: IPersistObject = {}

  set(key: keyof IPersistObject, value: ValueOf<IPersistObject>): void {
    this.object[key] = value
    this.persist()
  }

  get(key: keyof IPersistObject): ValueOf<IPersistObject> | null {
    return this.object[key] || null
  }

  hydrate(): void {
    try {
      const json = localStorage.getItem(this.rootKey)
      if (json) {
        this.object = JSON.parse(json)
      }
    } catch (e) {
      // @TODO Log to Sentry
      this.flush()
    }
  }

  private flush(): void {
    localStorage.setItem(this.rootKey, JSON.stringify({}))
  }

  private persist(): void {
    try {
      localStorage.setItem(this.rootKey, JSON.stringify(this.object))
    } catch (e) {
      this.flush()
    }
  }
}

export const persistService = new PersistService()
